import { useServices } from 'core/services';
import { CommunityMembershipRequestsResponse } from 'core/services/api/response-types';
import { MembershipRequest } from 'core/types';
import { communityKeys } from 'core/utils/query-key-factory';
import { useInfiniteQuery, InfiniteData } from '@tanstack/react-query';
import { BaseHttpError } from 'core/services/api/errors';
import { getPageParams } from 'core/utils/pagination';

export const useGetPendingRequests = (
	communityId: string,
	options: { enabled: boolean } = { enabled: true }
) => {
	const { api, authentication } = useServices();
	const isLoggedIn = authentication.isAuthenticated();

	return useInfiniteQuery<
		CommunityMembershipRequestsResponse,
		BaseHttpError,
		InfiniteData<MembershipRequest[]>
	>({
		queryKey: communityKeys.pendingRequests(communityId),
		queryFn: ({ pageParam = undefined, signal }) =>
			api.getCommunityMembershipRequests(communityId, {
				pagination: pageParam as any,
				signal,
			}),
		initialPageParam: undefined,
		enabled: !!communityId && isLoggedIn && options.enabled,
		select: response => {
			return {
				pages: response.pages.map(page => page.data),
				pageParams: response.pageParams,
			};
		},
		getPreviousPageParam: firstPage =>
			getPageParams(firstPage.pagination).previousParam,
		getNextPageParam: lastPage =>
			getPageParams(lastPage.pagination).nextParam,
		refetchOnMount: true,
		placeholderData: previousData => previousData,
	});
};
